import React from 'react';
import { Section } from './ui/Section';
export function Benefits() {
  const benefits = [{
    icon: '⚡',
    title: 'Clase lista en 10 minutos',
    desc: '12 meses planificados con fichas listas para usar cada semana. Ahorra 5+ horas semanales.'
  }, {
    icon: '🎯',
    title: 'Alumnas que no se van',
    desc: 'Sistema activo que detecta quién está por irse antes de que ocurra. Retención del 85%+.'
  }, {
    icon: '💰',
    title: 'Cobra lo que realmente valen tus clases',
    desc: 'La escalera de precios para subir tarifas sin perder ni una alumna. Posicionamiento premium.'
  }, {
    icon: '📱',
    title: 'Sala llena con anuncios',
    desc: 'Meta Ads y WhatsApp configurados para captar mientras descansas. Sistema automatizado.'
  }, {
    icon: '📈',
    title: 'Menos horas organizando y más tiempo enseñando',
    desc: 'El sistema para construir un negocio más grande que tú. Escalamiento real.'
  }, {
    icon: '👑',
    title: 'Conviértete en la instructora que todas recomiendan',
    desc: 'La metodología que te posiciona como referencia. Diferenciación profesional.'
  }];
  return <Section variant="alt" data-id="element-67">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-8 text-brand-title" data-id="element-68">
        🚀 LO QUE VAS A LOGRAR
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-69">
        {benefits.map((benefit, i) => <div key={i} className="bg-brand-card border border-brand-border rounded-2xl p-6 shadow-card hover:shadow-gold-glow transition-all hover:border-brand-borderGlow/60" data-id="element-70">
            <div className="text-5xl mb-4" data-id="element-71">{benefit.icon}</div>
            <h3 className="font-heading text-lg font-bold text-brand-title mb-3 tracking-wide" data-id="element-72">
              {benefit.title}
            </h3>
            <p className="font-body text-brand-text text-sm leading-relaxed" data-id="element-73">
              {benefit.desc}
            </p>
          </div>)}
      </div>
    </Section>;
}